import axios from 'axios'
import * as store from '../store'

let accessToken
store.accessToken.subscribe(value => {
    accessToken = value;
});

axios.defaults.headers.post = {}

export const axiosInstance = axios.create({
  baseURL: "API_ENDPOINT",
  headers: {
    'x-client': 'eiffel',
    post: {},
    put: {},
    patch: {}
  },
  transformRequest: [
    axios.defaults.transformRequest[0],
    function(data, headers) {
      if (!headers.Authorization && accessToken != null) {
        headers.Authorization = accessToken
      }
      return data
    }
  ],
  defaults: {
    headers: {
      post: {},
      put: {},
      patch: {}
    }
  }
})

const tokenMap = new Map()
export const TokenRegistry = {
  get(service, id) {
    return tokenMap.get(`/${service}/${id}`)
  }
}

axiosInstance.interceptors.response.use(response => {
  const token = response.headers['x-owner-token']
  if (token) {
    const location = `${response.config.url.replace(response.config.baseURL, '')}/${response.data.id}`
    tokenMap.set(location, token)
  }
  return response
})

axiosInstance.interceptors.request.use(request => {
  const url = request.url
  if (['put', 'patch'].includes(request.method) && tokenMap.has(url)) {
    request.headers['x-owner-token'] = tokenMap.get(url)
  }
  
  request.headers['x-client'] = "eiffel"

  return request
})

